// @ts-ignore
import React from 'react';
// import {
//   Box, Button, Checkbox, FormControlLabel,
// } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, FormControlLabel } from '../../../library';
import { TIMELINE_FILTER } from '../timeline.constants';

const TimeLineFilter = ({
  type,
  timelineFilterOptions,
  setTimelineFilterOptions,
  handleTimelineFilter,
}: {
  type: string;
  timelineFilterOptions: any;
  setTimelineFilterOptions: any;
  handleTimelineFilter: any;
}) => {
  const { t } = useTranslation();
  // @ts-ignore
  return (
    <>
      <h3 className="mw-150 fw-700 fs-18 mb-2 mt-0">
        {t(`timeline.${type}.title`)}
      </h3>
      <div className="d-flex flex-column flex-gap-1">
        {timelineFilterOptions.map(({ label, value }: any) => (
          <div key={label}>
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  key={label}
                  name={label}
                  checked={value}
                  onChange={(e) =>
                    handleTimelineFilter({ label, value: e.target.checked })
                  }
                />
              }
              label={<p className="!text-[14px] font-semibold">{t(label)}</p>}
            />
          </div>
        ))}
        <Button
          color="primary"
          variant="contained"
          onClick={() => setTimelineFilterOptions(TIMELINE_FILTER[type])}
          className="mt-1 w-100"
        >
          {t('clearFilters')}
        </Button>
      </div>
    </>
  );
};

export default TimeLineFilter;
